import moment from "moment";

import { INSIGHTS_LAUNCH_DATE } from "utils/insights";

/** Accounts created before the 1.0.0 launch are treated as fully verified. */
export const isAccountCreatedBeforeLaunch = (createdAt) => {
    if (!createdAt) return false;
    return moment(createdAt).isBefore(INSIGHTS_LAUNCH_DATE);
};

export const getEffectiveUserVerified = ({ createdAt, isUserVerified = false } = {}) => {
    if (isAccountCreatedBeforeLaunch(createdAt)) return true;
    return Boolean(isUserVerified);
};

export const getEffectiveEmailConfirmed = ({ createdAt, isEmailConfirmed = false } = {}) => {
    if (isAccountCreatedBeforeLaunch(createdAt)) return true;
    return Boolean(isEmailConfirmed);
};

/** Accounts created before 2025 were manually vetted REAs; missing flag means ERS access. */
export const ERS_ACCESS_CUTOFF_DATE = "2025-01-01";

/**
 * Resolve nonErsUser from stored user data.
 * Explicit flag wins; otherwise pre-2025 accounts get ERS access (nonErsUser: false).
 */
export const resolveNonErsUser = (userData = {}) => {
    if (userData.nonErsUser !== undefined && userData.nonErsUser !== null) {
        return Boolean(userData.nonErsUser);
    }

    const createdAt = userData.createdAt?.toDate?.() ?? userData.createdAt;
    if (createdAt && moment(createdAt).isBefore(ERS_ACCESS_CUTOFF_DATE)) {
        return false;
    }

    return true;
};

/** Registered Energy Advisors are flagged with nonErsUser === false. */
export const isRegisteredEnergyAdvisor = ({ nonErsUser } = {}) => nonErsUser === false;
